import type { BlogPost } from '../types'

const post: BlogPost = {
  title: 'EQ 1 – Self Awareness',
  slug: 'eq-1-self-awareness',
  category: 'EQ',
  date: '2025-05-16',
  image: '',
  excerpt: 'Self awareness – some ideas.',
  body: `Self-Awareness is knowing and understanding one's own emotions, motivations, strengths & weaknesses, values, and goals. Here are a few ideas to get to know yourself a little better.

1. Don't ignore your emotions. Lean into the discomfort. Notice how your body feels.
2. Don't judge your emotions or label them good or bad. Accept how you feel and move forward from there.
3. Make a list of what makes you upset. Parents? Roommate? Spouse? When you do X, I feel Y. Know what pushes your buttons.
4. Perspective. Try to see how you look from the outside, as a friend would see you.
5. Try a journal. Write about how you feel and what led to those feelings. Then look for how often you have the same trip-ups.
6. Don't make big decisions when feeling too good or too bad. That's when your perception is distorted.
7. Watch how your emotions affect the people around you.
8. Values. Make a list of the things that are fundamentally important to you. Then see how they drive your expectations and motivations.
9. Ask a friend. Ask someone who knows you how they see you. This will help in your own exercises with perspective.`,
}

export default post
